import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const PagamentoFinalizadoArea = () => {
  const query = new URLSearchParams(document.location.search);

  const transaction = query.get('transaction');
  const transactionStatus = query.get('transactionStatus');
  const linkBoleto = query.get('linkBoleto');
  const pixCodigo = query.get('pixQrCode');

  const [status, setStatus] = useState(null);
  const [description, setDescription] = useState(null);

  useEffect(() => {
    switch (transactionStatus) {
      case 'paid':
        setStatus('Pago');
        setDescription('Seu pagamento foi aprovado, bons estudos!');
        break;
      case 'processing':
        setStatus('Processando');
        setDescription(
          'Seu pagamento está processando, você será notificado por e-mail quando houver mudança neste status.'
        );
        break;
      case 'authorized':
        setStatus('Autorizado');
        setDescription('Seu pagamento foi autorizado, bons estudos!');
        break;
      case 'waiting_payment':
        setStatus('Aguardando pagamento');
        setDescription(
          'O banco pode levar até 48hs para compensar o pagamento, por isso pague o quanto antes, e aguarde a confirmação.'
        );
        break;
      case 'pending':
        setStatus('Aguardando pagamento');
        setDescription(
          'O banco pode levar até 48hs para compensar o pagamento, por isso pague o quanto antes, e aguarde a confirmação.'
        );
        break;
      case 'refused':
        setStatus('Pagamento não aprovado');
        setDescription(
          'Seu pagamento foi recusado. Entre em contato com a sua operadora solicitando a liberação, ou tente novamente.'
        );
        break;
      default:
        setStatus('Não identificado');
    }
  }, [transactionStatus]);

  return (
    <>
      <section className="po-rel-z1 pt-100 pb-145">
        <div className="container">
          <div className="row">
            <div className="col-xxl-12">
              <div className="section__title-wrapper text-center mb-55">
                <h2 className="section__title" style={{ textTransform: 'none' }}>
                  Recebemos o seu pedido de pagamento
                </h2>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xxl-12">
              <div className="sign__wrapper white-bg">
                <div className="sign__form">
                  <h4>
                    Seu código de pagamento é:{' '}
                    <span style={{ fontWeight: 'lighter' }}>{transaction}</span>
                  </h4>
                  <h5>Status do pedido: {status}</h5>
                  <p className="mt-5">{description}</p>

                  {linkBoleto && (
                    <a
                      className="btn btn-primary"
                      href={linkBoleto}
                      target="_blank"
                      rel="noreferrer"
                    >
                      Imprimir Boleto
                    </a>
                  )}

                  {pixCodigo && <p>Realize o pagamento no PIX através do QR Code:</p>}

                  {pixCodigo && <img src={pixCodigo} alt="PIX QR Code" />}

                  {pixCodigo && (
                    <p className="mt-3">
                      Assim que o pagamento for confirmado, você já poderá acessar o curso!
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PagamentoFinalizadoArea;
